import React, { useState } from "react";
//import styles from '../Assets/css/personalinfo.module.css'
import cantileverlabslogo from "../Assets/img/cantileverlabslogo.png";
import vector5 from "../Assets/img/vector5.jpeg";
import Navbar from "../components/Navbar";
import Vector from "../Assets/img/Vector.jpeg";
import arrow1 from "../Assets/img/arrow1.jpeg";
import Personal from "./Personal.js";
import CollegeDetails from "./CollegeDetails";
import Others from "./Others";
import useMedia from "./useMedia";
import MobileMasterClass from "./MobileMasterClass";
import styles from "../Assets/css/mobilemaster.module.css";
import { useEffect } from "react";
import { store } from "react-notifications-component";
import { Redirect } from "react-router-dom";
import MasterclassSuccess from "./MasterclassSuccess";
import BASE_URL from "../env";

const Personalinformation = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const refferal = queryParams.get("referral");
	const webinar_id = queryParams.get("webinar");
	const matches = useMedia("(min-width : 768px )");
	const [terms, setterms] = useState(true);
	const [collegeError, setCollegeError] = useState([]);
	const [firstName, setfirstName] = useState("");
	const [Email, setEmail] = useState("");
	const [PhoneNumber, setPhoneNumber] = useState("");
	const [currentCity, setCurrentCity] = useState("");
	const [Personalinfo, setpersonalinfo] = useState(true);
	const [collegeDetails, setCollegeDetails] = useState(false);
	const [otherss, setOthers] = useState(false);
	const [mainerror, setMainerror] = useState([[]]);
	const [mainerrorweb, setmainerrorWeb] = useState([[]]);
	//College Details
	const [graduation, setgraduation] = useState("Bachelor of Engg./tech");
	const [department, setdepartment] = useState("CSE");
	const [year, setyear] = useState("");
	const [semester, setSemester] = useState("");
	const [CollegeName, setCollegeName] = useState("");
	const [personalError, setpersonalError] = useState([]);
	const [otherError, setOtherError] = useState([]);
	const [City, setCity] = useState("");
	const [errors, setError] = useState([]);
	const [winningSuccess, setWinningSuccess] = useState(false);
	const notifyPopup = () => {
		store.addNotification({
			title: "Success!",
			message: "We got your response!!",
			type: "success",
			background: "pink",
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	};

	function HandleTheSubmit(e) {
		e.preventDefault();
	}
	function Citys(value) {
		setCity(value);
	}
	function Graduation(value) {
		setgraduation(value);
	}
	function Department(value) {
		setdepartment(value);
	}
	function Year(value) {
		setyear(value);
	}
	function Semester(value) {
		setSemester(value);
	}
	function College(value) {
		setCollegeName(value);
	}
	function Graduation(value) {
		setgraduation(value);
	}

	var weberror = "";

	//var error ="";
	//others component
	const [employecode, setemployecode] = useState("");
	const [radio, setradio] = useState("");
	const [question, setquestion] = useState("");

	const [yes, setyes] = useState(false);
	const [checkboxvalue, setcheckboxvalue] = useState({
		ProductDevelopment: false,
		SoftwareDevelopment: false,
		DataScience: false,
		MachineLearningAndArtificialIntelligence: false,
		CyberSecurity: false,
		FullStackDevelopment: false,
		others: false,
	});
	const {
		ProductDevelopment,
		SoftwareDevelopment,
		DataScience,
		MachineLearningAndArtificialIntelligence,
		CyberSecurity,
		FullStackDevelopment,
		others,
	} = checkboxvalue;

	var Totalerrors = "";

	//final submit
	var interestArray = [];
	async function HandleSubmit(e) {
		interestArray = [];
		e.preventDefault();
		setError([]);
		for (const [key, value] of Object.entries(checkboxvalue)) {
			if (value == true) {
				console.log(key);
				interestArray.push(key);
			}
		}
		console.log(interestArray);
		if (HandleValidation() == true) {
			for (const [key, value] of Object.entries(checkboxvalue)) {
				if (value == true) {
					interestArray.push(key);
				}
			}
		}
	}
	function setQuestion(value) {
		setquestion(value);
	}
	function Setemploye(value) {
		setemployecode(value);
	}
	function setRadio(value) {
		setradio(value);
	}
	let webinar_id_str = webinar_id.toString();
	console.log("Webinar Id", webinar_id_str);
	useEffect(() => {
		if (winningSuccess === false) {
			if (mainerrorweb.length === 1) {
				for (const [key, value] of Object.entries(checkboxvalue)) {
					if (value == true) {
						interestArray.push(key);
					}
				}
				// console.log(year)
				if (firstName !== "") {
					fetch(BASE_URL.BASE_URL + "/webinars/Addregistration", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							email: Email,
							webinarId: webinar_id_str,
							firstName: firstName,
							mobileNumber: PhoneNumber,
							currentCity: currentCity,
							yearOfStudy: year === "" ? "graduated" : year,
							semester: semester,
							graduationDegree: graduation,
							department: department,
							collegeName: CollegeName,
							areaOfInterest: interestArray,
							referalCode: employecode,
							questions: question,
						}),
					})
						.then((response) => response.json())
						.then((response) => {
							notifyPopup();
							SetSuccesState();
							//   window.open("/", "_self");
						})
						.catch((err) => {
							console.log("this is err ");
						});
				} else {
					console.log("I cannot send");
				}
			}
		}
	}, [mainerrorweb]);
	// This is for the desktop/webview
	function HandleValidation() {
		setError([]);
		setmainerrorWeb([[]]);
		var count = 0;
		Object.values(checkboxvalue).forEach((val) => {
			if (val == false) {
				count += 1;
			}
		});
		var Obj = Object.keys(checkboxvalue).length;
		if (terms == false) {
			setmainerrorWeb((mainerrorweb) => [
				...mainerrorweb,
				"please accept our terms and conditions",
			]);
			setError((errors) => [
				...errors,
				"please accept our terms and conditions",
			]);
		}
		if (count == Obj) {
			console.log("we are having an error");
			setmainerrorWeb((mainerrorweb) => [
				...mainerrorweb,
				"please select any one area of interest",
			]);
			weberror = "some value";
			setError((errors) => [
				...errors,
				"please select any one area of interest",
			]);
		} else {
			console.log("no errors");
		}

		if (terms == false && count == Obj) {
			return false;
		}

		if (errors.length == 0) {
			return true;
		}
	}

	function PersonalToCollegeDetails() {
		setpersonalinfo(false);
		setCollegeDetails(true);
	}
	function collegeDetailsToOther() {
		setCollegeDetails(false);
		setOthers(true);
	}
	function othersToCollegeDetials() {
		setOthers(false);
		setCollegeDetails(true);
	}
	function CollegeDetailsToPersonal() {
		setCollegeDetails(false);
		setpersonalinfo(true);
	}
	function setfirstNames(value) {
		setfirstName(value);
	}
	function setEMails(values) {
		setEmail(values);
	}
	function setPhoneNumbers(value) {
		setPhoneNumber(value);
	}
	function setCurrentcitys(values) {
		setCurrentCity(values);
	}
	function PersonalErrorHandling() {
		setpersonalError([]);
		var re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var Re = /(\+91)?(-)?\s*?(91)?\s*?(\d{3})-?\s*?(\d{3})-?\s*?(\d{4})/;

		if (Email !== "") {
			if (re.test(String(Email)) == false) {
				setpersonalError((personalError) => [
					...personalError,
					["Enter your email properly"],
				]);
			}
		}
		if (Email === "") {
			setpersonalError((personalError) => [
				...personalError,
				["Please enter your email"],
			]);
		}

		if (firstName == "") {
			setpersonalError((personalError) => [
				...personalError,
				["Please enter your first name"],
			]);
		}
		if (PhoneNumber !== "") {
			if (
				Re.test(String(PhoneNumber)) == false ||
				PhoneNumber.length > 10
			) {
				setpersonalError((personalError) => [
					...personalError,
					["Enter your correct phone Number"],
				]);
			}
		}
		if (PhoneNumber === "") {
			setpersonalError((personalError) => [
				...personalError,
				["Enter your phone Number"],
			]);
		}

		if (currentCity == "") {
			console.log("hello there");
			setpersonalError((personalError) => [
				...personalError,
				["Please Enter the city in the "],
			]);
		}

		if (
			currentCity !== "" &&
			Email !== "" &&
			firstName !== "" &&
			PhoneNumber !== "" &&
			PhoneNumber.length <= 10
		) {
			if (Re.test(String(PhoneNumber)) == true && PhoneNumber !== "") {
				//    seterror(...error,["Enter your first name properly"])
				//  error +="Enter your proper phone number/n";
				if (re.test(String(Email)) == true) {
					setpersonalError([]);
					return true;
				}
			}
		} else {
			console.log(currentCity);
			console.log(Email);
			console.log(firstName);
			console.log(PhoneNumber);
			//  alert("hello")
			console.log("error");
		}
	}
	function CollegeDetailss() {
		setCollegeError([[]]);
		if (graduation == "") {
			setCollegeError((collegeError) => [
				...collegeError,
				["please select the graduation"],
			]);
			//console.log(error)
		}
		if (department == "") {
			setCollegeError((collegeError) => [
				...collegeError,
				["please select the department"],
			]);
			//console.log(error)
		}
		if (yes == false) {
			if (year == "") {
				setCollegeError((collegeError) => [
					...collegeError,
					["please enter the year"],
				]);
				//console.log(error)
			}
			if (year > 4) {
				setCollegeError((collegeError) => [
					...collegeError,
					["please enter a valid year"],
				]);
				//console.log(error)
			}

			if (semester == "") {
				setCollegeError((collegeError) => [
					...collegeError,
					["please enter the semester"],
				]);
				//console.log(error)
			}
		}
		if (terms == false) {
			setCollegeError((collegeError) => [
				...collegeError,
				["Please Accept to our terms and conditions"],
			]);
		}
		if (CollegeName == "") {
			setCollegeError((collegeError) => [
				...collegeError,
				["please enter your college name"],
			]);
		}
		if (City == "") {
			setCollegeError((collegeError) => [
				...collegeError,
				["please enter the city name"],
			]);
		}
		if (
			(graduation !== "") &
				(department !== "") &
				(year !== "") &
				(semester !== "") &&
			CollegeName !== "" &&
			City !== "" &&
			terms == true
		) {
			// ye edit karru just for reference
			setCollegeError([]);
			return true;
		}
		//console.log(error.length)
		if (collegeError === [[]]) {
			setCollegeError([]);
			return true;
		}
	}

	useEffect(() => {
		setemployecode(refferal);
	}, [refferal]);
	useEffect(() => {
		console.log(mainerror);
		console.log(collegeError);
		console.log(personalError);
		if (collegeError.length == 1) {
			setCollegeError([]);
		}
		if (firstName !== "") {
			if (
				collegeError.length == 0 &&
				personalError.length == 0 &&
				mainerror.length == 0
			) {
				for (const [key, value] of Object.entries(checkboxvalue)) {
					if (value == true) {
						interestArray.push(key);
					}
				}
				console.log(interestArray);
				fetch(BASE_URL.BASE_URL + "/webinars/Addregistration", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						email: Email,
						webinarId: webinar_id_str,
						firstName: firstName,
						mobileNumber: PhoneNumber,
						currentCity: currentCity,
						yearOfStudy:
							year === "" || year == "graduated"
								? "graduated"
								: year,
						semester: semester,
						graduationDegree: graduation,
						department: department,
						collegeName: CollegeName,
						areaOfInterest: interestArray,
						referalCode: employecode,
						questions: question,
					}),
				})
					.then((response) => response.json())
					.then((response) => {
						notifyPopup();
						SetSuccesState();
						// window.open("/", "_self");
					})
					.catch((err) => {
						console.log("this is err ");
					});
			}
		}
	}, [mainerror, collegeError, personalError]);
	async function OthersValidate(e) {
		var count = 0;
		Object.values(checkboxvalue).forEach((val) => {
			if (val == false) {
				count += 1;
			}
		});
		var Obj = Object.keys(checkboxvalue).length;

		if (count == Obj) {
			setOtherError(["please select any one area of interest"]);
			setMainerror(["select any one option"]);
			return false;
		} else {
			setOtherError([]);
			setMainerror([]);
		}

		if (setOtherError.length == 0) {
			setOtherError([]);
			return true;
		} else {
		}
	}

	function SetSuccesState() {
		setOthers(false);
		setWinningSuccess(true);
	}
	function checkAllValues() {
		if (
			collegeError.length == 0 &&
			personalError.length == 1 &&
			mainerror.length == 0
		) {
			console.log("here here");
		}
	}
	async function HandleAllErrors(e) {
		e.preventDefault();
		for (const [key, value] of Object.entries(checkboxvalue)) {
			if (value == true) {
				interestArray.push(key);
			}
		}
		console.log(interestArray);
		setMainerror([]);
		setOtherError([]);
		setCollegeError([]);
		setpersonalError([]);

		PersonalErrorHandling();
		CollegeDetailss();
		await OthersValidate();

		//No collegeerror = 0 No personalError = 1 No main error 0
		if (OthersValidate() == true) {
			if (
				collegeError.length == 0 &&
				personalError.length == 1 &&
				mainerror.length == 0
			) {
				console.log("here here");
				//  alert("there are no errors in this document")
				// alert("college errors "+collegeError.length);
				// alert("personal errors " +personalError.length);
				// alert("main error" +mainerror.length)
			} else {
				console.log(personalError);
				console.log(collegeError);
				console.log(otherError);
			}
		}
		checkAllValues();
	}

	return (
		<>
			<Navbar />
			{matches == true ? (
				<>
					{Personalinfo == true && (
						<Personal
							values={{
								firstName: firstName,
								Email: Email,
								PhoneNumber: PhoneNumber,
								currentCity: currentCity,
								setfirstName: setfirstNames,
								setEmail: setEMails,
								setPhoneNumber: setPhoneNumbers,
								setCurrentCity: setCurrentcitys,
							}}
							Personal_to_College={PersonalToCollegeDetails}
						/>
					)}
					{collegeDetails == true && (
						<CollegeDetails
							College_to_others={collegeDetailsToOther}
							College_to_personal={CollegeDetailsToPersonal}
							values={{
								graduation: graduation,
								department: department,
								year: year,
								semester: semester,
								CollegeName: CollegeName,
								City: City,
								HandleTheSubmit: HandleTheSubmit,
								setgraduation: Graduation,
								setCity: Citys,
								setdepartment: Department,
								setyear: Year,
								setSemester: Semester,
								setCollegeName: College,
							}}
						/>
					)}
					{otherss == true && (
						<Others
							Others_to_College={othersToCollegeDetials}
							values={{
								employecode: employecode,
								radio: radio,
								question: question,
								HandleSubmit: HandleSubmit,
								setquestion: setQuestion,
								setradio: setRadio,
								setemployecode: Setemploye,
								errors: errors,
								checkboxvalue: checkboxvalue,
								setcheckboxvalue: setcheckboxvalue,
								terms: terms,
								setterms: setterms,
							}}
						/>
					)}
					{winningSuccess == true && <MasterclassSuccess />}
					{/* <Personal/> */}
					{/* <CollegeDetails/> */}{" "}
				</>
			) : (
				<>
					{" "}
					{winningSuccess == false ? (
						<div class="container-fluid styles.mainmobJ justify-content-center">
							<div class="row justify-content-center ">
								<div
									class={
										"col-sm-7 " +
										styles.purpleformMJ +
										" py-3 pb-5 px-5 " +
										styles.form1MJ
									}
								>
									<p>
										How to crack jobs in top product
										companies
									</p>
									<div class={styles.mobilehrwhiteJ}>
										<p class="mb-0">
											21st June, 2021 <br /> 5:00PM -
											6:00PM
										</p>
									</div>
								</div>
								<form onSubmit={HandleAllErrors}>
									<div
										class={
											"col-12 my-3 " +
											styles.secondpartformMJ
										}
									>
										<div class={styles.formMhd2J + " mt-5"}>
											<h2>Personal information</h2>
										</div>
										<div
											class={
												styles.formcenterMJ + " mt-5"
											}
										>
											<form class={styles.whiteformMJ}>
												<div>
													<span
														class={
															styles.boldformTextMJ
														}
													>
														First Name
													</span>
													<br />
													<input
														value={firstName}
														onChange={(e) => {
															setfirstName(
																e.target.value
															);
														}}
														class={
															styles.formcontrol1
														}
														type="text"
														name="name"
														placeholder="John"
													/>
												</div>
												<br />
												<div class="mt-1">
													<span
														class={
															styles.boldformTextMJ
														}
													>
														Email
													</span>
													<br />
													<input
														value={Email}
														onChange={(e) => {
															setEmail(
																e.target.value
															);
														}}
														class={
															styles.formcontrol1
														}
														type="email"
														name="email"
														placeholder="xyz@gmail.com"
													/>
												</div>
												<br />
												<div class="mt-1">
													<span
														class={
															styles.boldformTextMJ
														}
													>
														Phone Number
													</span>
													<br />
													<input
														value={PhoneNumber}
														onChange={(e) =>
															setPhoneNumber(
																e.target.value
															)
														}
														class={
															styles.formcontrol1 +
															" " +
															styles.numInput
														}
														type="number"
														name="Phone"
														placeholder="Do not put country code"
													/>
												</div>
												<br />
												<div class="mt-1">
													<span
														class={
															styles.boldformTextMJ
														}
													>
														Current City
													</span>
													<br />
													<input
														value={currentCity}
														onChange={(e) => {
															setCurrentCity(
																e.target.value
															);
														}}
														class={
															styles.formcontrol1
														}
														type="text"
														name="city"
														placeholder="Enter your city name"
													/>
												</div>
											</form>
										</div>

										<div class={styles.formMhd2J + " mt-5"}>
											<h2>College Details</h2>
										</div>

										<div class="mt-5">
											<span class={styles.boldformTextMJ}>
												Graduation Degree
											</span>
											<br />

											<div
												class="mt-2"
												data-role="fieldcontain"
											>
												<select
													style={{
														width: "58%",
														marginLeft: "2px",
														marginTop: "2px",
													}}
													value="Bachelor of Engg./tech"
													onChange={(e) => {
														setCollegeName(
															e.target.value
														);
													}}
												>
													<option value="Bachelor of Engg./tech">
														Bachelor of Engg./tech
													</option>
													<option value="Bachelor of Commerce">
														Bachelor of Commerce
													</option>
													<option value="PGDM/MBA">
														PGDM/MBA
													</option>
													<option value="BBA">
														BBA
													</option>
													<option value="Others">
														Others
													</option>
												</select>
												<fieldset
													data-role="controlgroup"
													data-type="horizontal"
												>
													<br />
													<br />
												</fieldset>
											</div>
											<br />

											<div class="mt-1">
												<span
													class={
														styles.boldformTextMJ
													}
												>
													Department
												</span>
												<br />

												<div class="mt-2">
													<select
														style={{
															width: "60%",
															marginLeft: "2px",
															marginTop: "2px",
														}}
														id="dropdown"
														onChange={(e) => {
															setdepartment(
																e.target.value
															);
														}}
													>
														<option value="CSE">
															CSE
														</option>
														<option value="ECE">
															ECE
														</option>
														<option value="EEE">
															EEE
														</option>
														<option value="IT">
															IT
														</option>
														<option value="MECH">
															MECH
														</option>
														<option value="CIVIL">
															CIVIL
														</option>
														<option value="OTHERS">
															OTHERS
														</option>
													</select>
													<br />
													{/* <input style={{marginRight: "5px"}}type = "radio"  name="radio-1"   id="radio-1" value="CSE" checked={department == "CSE"}
                                                    onChange={(e) => setdepartment(e.target.value)}/>
                            <label  class={styles.radiotextJ} for="radio-1" >CSE</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-2" value="ECE"
                                                    checked={department == "ECE"} onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-2" >ECE</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-3" value="EEE" checked={department == "EEE"}
                                                    onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-3" >EEE</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-4" value="IT" checked={department == "IT"}
                                                    onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-4" >IT</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-5" value="MECH" checked={department == "MECH"} onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-5" >MECHANICAL</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-6"  value="CIVIL" checked={department == "CIVIL"} onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-6" >CIVIL</label>
                            <br />
                            <br />
                            <input style={{marginRight: "5px"}}type = "radio" class="ml-2" name="radio-1"   id="radio-7" value="OTHERS" checked={department == "OTHERS"} onChange={function (e) {
                                        setdepartment(e.target.value);
                                    }} />
                            <label  class={styles.radiotextJ} for="radio-7" >OTHERS</label> */}
												</div>
											</div>
											<br />

											<div class="mt-1">
												<span
													class={
														styles.boldformTextMJ
													}
												>
													Graduated
												</span>
												<div className="row">
													<div className="col">
														<br />
														<input
															style={{
																marginRight:
																	"5px",
															}}
															checked={
																yes == true
															}
															type="radio"
															name="yes"
															id="yes"
															onChange={() =>
																setyes(!yes)
															}
														/>
														<label
															style={{
																marginLeft:
																	"4%",
															}}
															className="ml-2"
															for="yes"
														>
															yes
														</label>
													</div>
													<div className="col">
														<br />
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="radio"
															name="bo"
															id="no"
															checked={
																yes == false
															}
															onChange={() =>
																setyes(!yes)
															}
														/>
														<label
															style={{
																marginLeft:
																	"4%",
															}}
															className="ml-2"
															for="no"
														>
															no
														</label>
													</div>
												</div>
											</div>

											<br />
											{yes == false && (
												<div class="">
													<span
														class={
															styles.boldformTextJ
														}
													>
														Year of study &#38;
														Semester:{" "}
													</span>
													<br />
													<br />
													<div className="row">
														<div
															className="col-lg-3"
															style={{
																float: "left",
																marginLeft:
																	"0px",
																paddingLeft:
																	"0px",
															}}
														>
															<input
																value={year}
																onChange={(e) =>
																	setyear(
																		e.target
																			.value
																	)
																}
																style={{
																	float: "left",
																	padding:
																		"3px",
																}}
																className="card shadow pr-1 pl-1"
																style={{
																	width: "40%",
																}}
																type="number"
																name=""
																id=""
															/>
														</div>
														<div
															className="col-lg-3"
															style={{
																float: "left",
																marginLeft:
																	"0px",
																paddingLeft:
																	"0px",
															}}
														>
															<input
																value={semester}
																onChange={(e) =>
																	setSemester(
																		e.target
																			.value
																	)
																}
																className="card shadow pr-1 pl-1"
																style={{
																	width: "40%",
																	padding:
																		"2px",
																}}
																type="number"
																name=""
																id=""
															/>
														</div>
													</div>
												</div>
											)}
										</div>
										<div
											class={"mt-2 " + styles.whiteformMJ}
										>
											<span class={styles.boldformTextJ}>
												College Name
											</span>
											<span
												class={styles.boldformTextJ}
												style={{ marginLeft: "17%" }}
											>
												Current City
											</span>
											<br />

											<input
												className={styles.formcontrol1}
												value={CollegeName}
												onChange={(e) =>
													setCollegeName(
														e.target.value
													)
												}
												style={{
													width: "40%",
													marginLeft: "1px",
												}}
												type="text"
												name="city"
												placeholder="Enter your college name"
											/>
											<input
												className={styles.formcontrol1}
												value={City}
												onChange={(e) =>
													setCity(e.target.value)
												}
												style={{
													width: "38%",
													marginLeft: "7%",
													marginTop: "2px",
												}}
												type="text"
												name="city"
												placeholder="Enter your college city"
											/>
										</div>

										<div class={styles.formMhd2J + " mt-5"}>
											<h2>Others</h2>
										</div>

										<div
											class={styles.whiteformMJ}
											onSubmit={OthersValidate}
										>
											<div class="mt-5">
												<span
													class={
														styles.boldformTextMJ
													}
												>
													Area Of Interest
												</span>
												<br />
												<div class="row d-flex mt-2">
													<div class=" ml-3 mb-2">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-1"
															value="Product Development"
															checked={
																ProductDevelopment ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		ProductDevelopment:
																			!ProductDevelopment,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-1"
														>
															Product Development
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-2"
															value="Software Development"
															checked={
																checkboxvalue.SoftwareDevelopment ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		SoftwareDevelopment:
																			!SoftwareDevelopment,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-2"
														>
															Software developmet
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-3"
															value="Data science"
															checked={
																checkboxvalue.DataScience ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		DataScience:
																			!DataScience,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-3"
														>
															Datascience
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-4"
															value="Machine learning and Artificial Intelligence"
															checked={
																checkboxvalue.MachineLearningAndArtificialIntelligence ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		MachineLearningAndArtificialIntelligence:
																			!MachineLearningAndArtificialIntelligence,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-4"
														>
															Machine Learning and{" "}
															<br /> Artificial
															Intelligence{" "}
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-5"
															value="Cyber Security"
															checked={
																checkboxvalue.CyberSecurity ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		CyberSecurity:
																			!CyberSecurity,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-5"
														>
															Cyber Security{" "}
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															name="radio-1"
															id="radio-6"
															checked={
																checkboxvalue.FullStackDevelopment ==
																true
															}
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		FullStackDevelopment:
																			!FullStackDevelopment,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-6"
														>
															Full Stack
															Development
														</label>
													</div>
													<div class=" ml-3 mb-2 ">
														<input
															style={{
																marginRight:
																	"5px",
															}}
															type="checkbox"
															style={{
																marginRight:
																	"5px",
															}}
															name="radio-1"
															id="radio-7"
															checked={
																checkboxvalue.others ==
																true
															}
															id="radio-7"
															value="Others"
															onChange={function (
																e
															) {
																setcheckboxvalue(
																	{
																		...checkboxvalue,
																		others: !others,
																	}
																);
															}}
														/>
														<label
															class={
																styles.radiotextJ
															}
															for="radio-7"
														>
															Others{" "}
														</label>
													</div>
												</div>

												<br />
												<div>
													<span
														class={
															styles.boldformTextMJ
														}
													>
														Enter Employee Refer
														code if any
													</span>
													<br />
													<input
														value={employecode}
														onChange={(e) => {
															setemployecode(
																e.target.value
															);
														}}
														style={{
															marginRight: "5px",
														}}
														class={
															styles.formcontrol1
														}
														type="text"
														name="city"
														placeholder="Type code here"
													/>
												</div>
												<br />
												<div>
													<span
														class={
															styles.boldformTextMJ
														}
													>
														{" "}
														Do you have any Question
														to the speaker ?
													</span>
													<br />
													<input
														class={
															styles.formcontrol1
														}
														type="text"
														name="city"
														placeholder=" Enter Your Question"
														value={question}
														onChange={(e) =>
															setQuestion(
																e.target.value
															)
														}
													/>
												</div>

												<div class="my-5">
													{/* {((mainerror.length > 0) || (collegeError.length > 0) || (personalError.length >= 0) ) && <>
                                    <div className="alert alert-info" role="alert">
                                                    {mainerror.map((main, index) => {
                                                        return <>
                                                            <p>{ main}</p>
                                                            </>
                                                    })}

                                                    {collegeError.length > 0 &&   <>{collegeError.map((value,id)=>{
                                                        return (
                                                            <>
                                                                <p id={id}>{value}</p>
                                                                {personalError.length > 0 && <> {personalError.map((values, ids) => {
                                                                    return <>
                                                                        <p key={ids}>{values}</p>
                                                                        </>
                                                                })}
                                                                </>}
                                                            </>
                                                        )

                                                    })}
                                                    </>}

                                                </div>
                                     </>} */}
													{mainerror.length > 0 && (
														<>
															{" "}
															{mainerror.map(
																(
																	main,
																	index
																) => {
																	return (
																		<>
																			{" "}
																			<p>
																				{
																					main
																				}
																			</p>{" "}
																		</>
																	);
																}
															)}{" "}
														</>
													)}
													{collegeError.length >
														0 && (
														<>
															{collegeError.map(
																(
																	value,
																	index
																) => {
																	return (
																		<>
																			<p>
																				{
																					value
																				}
																			</p>
																		</>
																	);
																}
															)}
														</>
													)}
													{personalError.length >
														0 && (
														<>
															{personalError.map(
																(
																	value,
																	index
																) => {
																	return (
																		<>
																			<p>
																				{
																					value
																				}
																			</p>
																		</>
																	);
																}
															)}{" "}
														</>
													)}
												</div>

												<div
													style={{ float: "left" }}
													class={
														styles.leftformtextMJ +
														" my-5"
													}
												>
													<p>
														{" "}
														<input
															type="checkbox"
															id="term"
															checked={
																terms == true
															}
															onChange={(e) => {
																setterms(
																	!terms
																);
															}}
														/>{" "}
														You agree to our
														<a
															href="/policies/#terms"
															target="__blank"
														>
															<span
																class={
																	styles.purpleboldMJ
																}
															>
																{" "}
																Terms &
																Conditions
															</span>
														</a>{" "}
													</p>

													<div class="d-flex mt-2">
														{/* <button class={"btn " + styles.buttonformMJ + " p-2 mx-2"}>BACK</button> */}
														<button
															class={
																"btn " +
																styles.buttonformMJ +
																" p-2"
															}
														>
															SUBMIT
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					) : (
						<MasterclassSuccess />
					)}{" "}
				</>
			)}
		</>
	);
};

export default Personalinformation;
